import { request } from "../utils/request.js"


export const commodityInputOrder_exportForManage = (pojo, args) => request({
    url: 'commodityInputOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityInputOrder_findPageForManage = (pojo, args) => request({
    url: 'commodityInputOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityInputOrder_findPageListForManage = (pojo, args) => request({
    url: 'commodityInputOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityInputOrder_findPageForDeliveryManage = (pojo, args) => request({
    url: 'commodityInputOrder/findPageForDeliveryManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityInputOrder_findPageListForDeliveryManage = (pojo, args) => request({
    url: 'commodityInputOrder/findPageListForDeliveryManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityInputOrder_findPageForCurrentUserDelivery = (pojo, args) => request({
    url: 'commodityInputOrder/findPageForCurrentUserDelivery',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityInputOrder_findPageListForCurrentUserDelivery = (pojo, args) => request({
    url: 'commodityInputOrder/findPageListForCurrentUserDelivery',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityInputOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'commodityInputOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodityInputOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'commodityInputOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

// 获取配送员
export const commodityInputOrder_findDeliveryUser = (id, args) => request({
    url: 'commodityInputOrder/findDeliveryUser',
    method: 'GET',
    params: {
        id: id
    },
    showFailMessage: true,
    ...args
})

export const commodityInputOrder_saveIntoDraft = (pojo, args) => request({
    url: 'commodityInputOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityInputOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'commodityInputOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityInputOrder_update = (pojo, args) => request({
    url: 'commodityInputOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityInputOrder_updateAndSubmit = (pojo, args) => request({
    url: 'commodityInputOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityInputOrder_submitById = (id, args) => request({
    url: 'commodityInputOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityInputOrder_deleteById = (id, args) => request({
    url: 'commodityInputOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityInputOrder_approval = (pojo, args) => request({
    url: 'commodityInputOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityInputOrder_startDelivery = (id, args) => request({
    url: 'commodityInputOrder/startDelivery',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityInputOrder_completeDelivery = (id, args) => request({
    url: 'commodityInputOrder/completeDelivery',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


export const commodityInputOrder_confirmDelivery = (id, args) => request({
    url: 'commodityInputOrder/confirmDelivery',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodityInputOrder_findById = (id, args) => request({
    url: 'commodityInputOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const commodityInputOrder_findVoById = (id, args) => request({
    url: 'commodityInputOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const commodityInputOrder_generatePrintPdf = (pojo, args) => request({
    url: 'commodityInputOrder/generatePrintPdf',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/commodityInputOrder.js